import { createConfigCrud } from "features/shared/lib/technical-config-tab/api/crudCallers";

import type { CommonProps, SaveWindowConfigProps, WindowConfigSavePayload } from "../model/types";

import windowConfigTabUrls from "./urls";

const windowConfigCrud = createConfigCrud<WindowConfigSavePayload | WindowConfigSavePayload>(
  windowConfigTabUrls.groupDetail
);

export const saveWindowConfig = ({
  data,
  hasTechnology,
  projectId,
  scenario,
  userDefinedType,
}: SaveWindowConfigProps) =>
  windowConfigCrud.save({ data, isExisting: hasTechnology, projectId, recordId: userDefinedType, scenario });

export const deleteWindowConfig = ({ projectId, scenario, userDefinedType }: CommonProps) =>
  windowConfigCrud.remove({ projectId, recordId: userDefinedType, scenario });
